import { HTLabel } from './ht/index'
import { TTCLabel } from './ttc/index'
import VatLabel from './VatLabel'

export { HTLabel, TTCLabel, VatLabel }
